import { MutationKeyConfig } from '../api-helper';

export const serviceMunicipalityMappingsApiKeyStore = {
  editServiceMunicipality: (): MutationKeyConfig => ({
    mutationKey: [`_SERVICES`],
    route: `/Service/MunicipalityMappings`,
    action: 'PUT',
  }),
  createServiceMunicipalityMappings: (): MutationKeyConfig => ({
    mutationKey: [`CREATE_SERVICES_MUNICIPALITY_MAPPING`],
    route: `/Service/MunicipalityMappings`,
    action: 'POST',
  }),
  deleteServiceMunicipality: (id: number): MutationKeyConfig => ({
    mutationKey: [`SERVICES_MUNICIPALITY_MAPPING_DELETE`],
    route: `/Service/MunicipalityMappings/${id}`,
    action: 'DELETE',
  }),
};
